import { Fragment } from "react";
import { cn } from "@/lib/utils";

// Renders a knowledge-search snippet that the server has wrapped with
// `<mark>...</mark>` markers around the matched terms. We split on those
// markers and emit React elements directly — no dangerouslySetInnerHTML
// involved, so the surrounding text gets React's automatic escaping and we
// can't accidentally inject other HTML if the snippet ever contains it.
const MARK_RE = /<mark>([\s\S]*?)<\/mark>/g;

export function HighlightedSnippet({
  snippet,
  className,
  testId,
}: {
  snippet: string;
  className?: string;
  testId?: string;
}) {
  const parts: { text: string; mark: boolean }[] = [];
  let last = 0;
  let m: RegExpExecArray | null;
  MARK_RE.lastIndex = 0;
  while ((m = MARK_RE.exec(snippet))) {
    if (m.index > last) {
      parts.push({ text: snippet.slice(last, m.index), mark: false });
    }
    parts.push({ text: m[1], mark: true });
    last = MARK_RE.lastIndex;
  }
  if (last < snippet.length) {
    parts.push({ text: snippet.slice(last), mark: false });
  }
  if (parts.length === 0) {
    parts.push({ text: snippet, mark: false });
  }

  return (
    <p
      className={cn("text-xs leading-snug text-muted-foreground", className)}
      data-testid={testId}
    >
      {parts.map((part, i) =>
        part.mark ? (
          <mark
            key={i}
            className="rounded-sm bg-yellow-200 px-0.5 font-medium text-foreground dark:bg-yellow-700/50 dark:text-foreground"
          >
            {part.text}
          </mark>
        ) : (
          <Fragment key={i}>{part.text}</Fragment>
        ),
      )}
    </p>
  );
}
